import { useState } from 'react';
import { cn } from '../../../lib/utils';
import { Tab } from './interface';
import { UsersTab, JobTitlesTab } from './partials';

export function UsersPage() {
  const [tab, setTab] = useState<Tab>('users');

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Users</h1>

      <div className="flex gap-1 rounded-lg bg-slate-100 dark:bg-slate-800 p-1 w-fit">
        <button
          onClick={() => setTab('users')}
          className={cn(
            'px-4 py-1.5 rounded-md text-sm font-medium transition-colors',
            tab === 'users'
              ? 'bg-white dark:bg-slate-900 shadow-sm text-slate-900 dark:text-white'
              : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200',
          )}
        >
          Users
        </button>
        <button
          onClick={() => setTab('job-titles')}
          className={cn(
            'px-4 py-1.5 rounded-md text-sm font-medium transition-colors',
            tab === 'job-titles'
              ? 'bg-white dark:bg-slate-900 shadow-sm text-slate-900 dark:text-white'
              : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200',
          )}
        >
          Job Titles
        </button>
      </div>

      {tab === 'users' ? <UsersTab /> : <JobTitlesTab />}
    </div>
  );
}
